"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommonPinningStyles = void 0;
const getCommonPinningStyles = (column, isReady) => {
    const isPinned = column.getIsPinned();
    const isLastLeftPinnedColumn = isPinned === 'left' && column.getIsLastColumn('left');
    const isFirstRightPinnedColumn = isPinned === 'right' && column.getIsFirstColumn('right');
    const maxWidth = column.columnDef.maxSize;
    const minWidth = column.columnDef.minSize;
    const width = column.getSize();
    const columnIndex = column.getIndex();
    let padding = '1rem';
    let margin = '0';
    if (columnIndex === 0) {
        padding = '1rem 0 1rem 1rem';
    }
    if (columnIndex === 1) {
        padding = '1rem 1rem 1rem 0.5rem';
    }
    let boxShadow;
    if (isLastLeftPinnedColumn) {
        boxShadow = 'inset -1px 0 0 rgba(0, 0, 0, 0.16)';
    }
    if (isFirstRightPinnedColumn) {
        boxShadow = 'inset 1px 0 0 rgba(0, 0, 0, 0.16)';
        // This is for using margin instead of padding for the Actions column
        if (isReady) {
            margin = '0 1rem';
            padding = '0';
        }
    }
    return {
        left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
        right: isPinned === 'right' ? `${column.getAfter('right')}px` : undefined,
        position: isPinned ? 'sticky' : 'relative',
        zIndex: isPinned ? 1 : 0,
        width,
        minWidth,
        maxWidth,
        padding,
        margin,
        boxShadow,
    };
};
exports.getCommonPinningStyles = getCommonPinningStyles;
